import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useFirebase from "../../../../../useFirebase";
import { useHistory } from "react-router-dom";
import { setRuleDataSetUp } from "../../../AxiosRtk/SetRules";
import { setShowMessage } from "../../../AxiosRtk/successMessage";
import { setRulesKeystrokeStatus } from "../../../AxiosRtk/SetRules";

const KeyStrokes = ({ deviceSelected, getLangTranslation }) => {
  const [setRuleKeyStrokeData, setKeyStrokeData] = useState();
  const [formattedKeywords, setFormattedKeywords] = useState([]);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false); // state for duplicate keyword alert
  const [keyInput, setKeyInput] = useState("");
  const history = useHistory();
  const { setRulesData } = useSelector(({ setRules }) => setRules);
  const { selectedKidId: kidId } = useSelector(({ dashboard }) => dashboard);

  const { postCollectionData, getCollectionData, createCollectionData } =
    useFirebase();
  const dispatch = useDispatch();

  useEffect(() => {
    if (deviceSelected) {
      getCollectionData(deviceSelected);
    } else {
      setRuleDataSetUp(null);
    }
  }, [deviceSelected]);

  function callFirestore(payload) {
    let newPayload = {};
    if (payload?.activate) {
      newPayload["setRulesActiveInActiveStatus"] = {
        ...setRulesData?.setRulesActiveInActiveStatus,
        keysrtrokesMonitoringEnabled: payload?.activate ? true : false,
      };
      newPayload["keystrokesmonitoring"] = {
        keystrokesdata: payload,
      };
    } else {
      newPayload["keystrokesmonitoring"] = {
        keystrokesdata: payload,
      };
    }

    if (setRulesData) {
      postCollectionData(deviceSelected, newPayload);
    } else {
      createCollectionData(deviceSelected, newPayload);
    }
    getCollectionData(deviceSelected);
  }

  // function handleChange(e) {
  //   const { name, checked } = e.target;

  //   const collectionPayload = {
  //     ...setRuleKeyStrokeData,
  //   };

  //   if (name === "ENABLE_KEYSTROKES") {
  //     collectionPayload["activate"] = checked ? 1 : 0;
  //     collectionPayload["activateNotification"] = 0;
  //     collectionPayload["activateScreenshot"] = 0;
  //   } else if (name === "ACTIVATE_SCREENSHOT") {
  //     collectionPayload["activateNotification"] = checked ? 1 : 0;
  //   } else if (name === "ACTIVATE_SOCIAL_MEDIA") {
  //     collectionPayload["activateScreenshot"] = checked ? 1 : 0;
  //   }

  //   callFirestore(collectionPayload);
  // }
  function handleChange(e) {
    const { name, checked } = e.target;
  
    setKeyStrokeData((prevData) => {
      const updatedData = { ...prevData };
  
      if (name === "ENABLE_KEYSTROKES") {
        updatedData["activate"] = checked ? 1 : 0;
        updatedData["activateNotification"] = 0; // Reset dependent toggles
        updatedData["activateScreenshot"] = 0;
      } else if (name === "ACTIVATE_SCREENSHOT") {
        updatedData["activateNotification"] = checked ? 1 : 0;
      } else if (name === "ACTIVATE_SOCIAL_MEDIA") {
        updatedData["activateScreenshot"] = checked ? 1 : 0;
      }
  
      // Immediately call Firestore with updated data
      callFirestore(updatedData);
  
      return updatedData; // Update local state synchronously
    });
  }
  

  useEffect(() => {
    if (setRulesData) {
      setKeyStrokeData(setRulesData?.keystrokesmonitoring?.keystrokesdata);
      const { keystroke_keywords } =
        setRulesData?.keystrokesmonitoring?.keystrokesdata ?? {};
      if (keystroke_keywords) {
        const keywords = [
          ...setRulesData?.keystrokesmonitoring?.keystrokesdata
            ?.keystroke_keywords,
        ];

        const keywordArr = keywords?.map((item) => ({
          id: Math.floor(Math.random() * Math.pow(10, 6)),
          key: item,
        }));

        setFormattedKeywords(keywordArr);
      }
    } else {
      setKeyStrokeData(null);
    }
  }, [setRulesData]);

  function handleKeywordRemove(id) {
    const indexToRemove = formattedKeywords?.findIndex(
      (item) => parseInt(item?.id) === parseInt(id)
    );
    formattedKeywords?.splice(indexToRemove, 1);

    const collectionPayload = {
      ...setRuleKeyStrokeData,
      keystroke_keywords: formattedKeywords?.map((item) => item?.key),
    };

    callFirestore(collectionPayload);
  }

  function handleContinue() {
    if (!keyInput) {
      history.push("/keystrokes-select-apps");
      return;
    }

    const newKeywords = keyInput.split(",").map((item) => item.trim());
    const existingKeywords = formattedKeywords.map((item) => item.key);

    // Check for duplicates
    const duplicateKeywords = newKeywords.filter((keyword) =>
      existingKeywords.includes(keyword)
    );

    if (duplicateKeywords.length > 0) {
      // Show message and prevent adding duplicate keywords

      setTimeout(() => {
        dispatch(
          setShowMessage({
            showMessage: true,
            defaultMessage: "This keystroke is already added.",
            message: "KEYSTROKE_EXIST",
          })
        );
      }, 1000);

      return; // Stop further execution to prevent adding the duplicate keywords
    }

    const keysToRender = newKeywords.map((item) => ({
      id: Math.floor(Math.random() * Math.pow(10, 6)),
      key: item,
    }));

    const collectionPayload = {
      ...setRuleKeyStrokeData,
      keystroke_keywords: [
        ...(setRuleKeyStrokeData?.keystroke_keywords ?? []),
        ...keysToRender.map((item) => item?.key),
      ],
    };

    setKeyInput(""); // Clear the input field
    callFirestore(collectionPayload); // Save the keywords

    // api call for keystrokes monitoring
    setRulesKeystrokeStatus({
      IsActivate: 1,
      deviceId: deviceSelected,
      isEnableSupervision: 1,
      isKeystrokeKeywords: [
        ...(setRuleKeyStrokeData?.keystroke_keywords ?? []),
        ...keysToRender.map((item) => item?.key),
      ],
      isLoadDefaultSettings: 0,
      kidId,
    })
      .then((res) => {
        console.log(res);
        history.push("/keystrokes-select-apps"); // Redirect to the appropriate page
      })
      .catch((err) => {
        console.log(err);
      });


  }

  function handleClearAll() {
    setKeyInput("");
    const collectionPayload = {
      ...setRuleKeyStrokeData,
      keystroke_keywords: [],
    };

    callFirestore(collectionPayload);
  }

  function closeModal() {
    setShowDuplicateModal(false);
  }

  if (!deviceSelected) {
    return (
      <div className="text-center my-3">
        -- {getLangTranslation("DEVICE_NOT_SELECTED", "Device not selected")} --
      </div>
    );
  }

  return (
    <>
      <div
        className="alert alert-success alert-dismissible fade show d-flex align-items-center gap-3 mb-6 fw-semibold"
        role="alert"
      >
        <i className="icon-info-one fs-5" />
        {getLangTranslation(
          "KEYSTROKES_MONITORING_DESCRIPTION_1",
          "When this feature is activated, all words typed by your child anywhere will be recorded for you"
        )}
        {/* <button
          type="button"
          className="btn-close"
          data-bs-dismiss="alert"
          aria-label="Close"
        ></button> */}
      </div>

      {showDuplicateModal && (
        <div className="modal">
          <div className="modal-content">
            <p>
              {getLangTranslation(
                "KEYWORD_ALREADY_ADDED",
                "This keyword is already added!"
              )}
            </p>
            <button onClick={closeModal}>Close</button>
          </div>
        </div>
      )}

      <div className="form-check form-switch mb-6">
        <input
          className="form-check-input"
          id="ENABLE_KEYSTROKES"
          type="checkbox"
          role="switch"
          name="ENABLE_KEYSTROKES"
          checked={setRuleKeyStrokeData?.activate ?? 0}
          onChange={handleChange}
        />
        <label
          className="form-check-label text-blue-800 fw-semibold"
          htmlFor="ENABLE_KEYSTROKES"
        >
          {getLangTranslation(
            "KEYSTROKES_MONITORING_ENABLE_KEYSTROKE",
            "Enable keystrokes"
          )}
        </label>
      </div>

      {setRuleKeyStrokeData?.activate === 1 && deviceSelected && (
        <>
          <div className="row align-items-end g-3 mb-6">
            <div className="col-auto flex-grow-1">
              <div className="form-group">
                <label htmlFor="ADD_KEYWORDS" className="mb-3 text-dark">
                  {getLangTranslation(
                    "KEYSTROKES_MONITORING_ADD_KEYSTROKE_DECRIPTION",
                    "Add keywords to be flagged and you will be alerted if any of these words are typed anywhere by your child"
                  )}
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="ADD_KEYWORDS"
                  name="ADD_KEYWORDS"
                  placeholder="Enter keywords to be flagged separated by a comma"
                  value={keyInput}
                  onChange={(e) => setKeyInput(e.target.value)}
                />
              </div>
            </div>
            <div className="col-auto">
              <button
                className="btn btn-outline-primary"
                onClick={handleClearAll}
              >
                <span className="btn-upper-case">
                  {getLangTranslation("CLEAR_ALL", "Clear all")}
                </span>
              </button>
            </div>
            <div className="col-auto">
              <button className="btn btn-primary" onClick={handleContinue}>
                <span className="btn-upper-case">
                  {getLangTranslation("CONTINUE", "Continue")}
                </span>
              </button>
            </div>
          </div>

          <div className="d-inline-flex flex-wrap gap-3 mb-6">
            {formattedKeywords?.map((item) => (
              <div className="custom-tag" key={item?.id}>
                {item?.key}
                <i
                  className="icon-cancel ms-1 pt-cursor"
                  onClick={() => handleKeywordRemove(item?.id)}
                />
              </div>
            ))}
          </div>

          <div className="form-check form-switch mb-6">
            <input
              className="form-check-input mt-3"
              id="ACTIVATE_SCREENSHOT"
              type="checkbox"
              role="switch"
              name="ACTIVATE_SCREENSHOT"
              checked={setRuleKeyStrokeData?.activateNotification ?? 0}
              onChange={handleChange}
            />
            <label className="form-check-label" htmlFor="ACTIVATE_SCREENSHOT">
              <span className="text-dark fw-semibold">
                {getLangTranslation(
                  "KEYSTROKES_MONITORING_ACTIVATE_KEYWORD_ALERT_ON_SS",
                  "Activate keywords alerts on screenshots text detection"
                )}
              </span>
              <p className="text-small mb-0">
                {getLangTranslation(
                  "KEYSTROKES_MONITORING_ACTIVATE_KEYWORD_ALERT_ON_SS_DESCRIPTION",
                  "This option allow you to get alerted when any keywords above will be detected in screenshot text detected related to social media."
                )}
              </p>
            </label>
          </div>

          <div className="form-check form-switch">
            <input
              className="form-check-input mt-3"
              id="ACTIVATE_SOCIAL_MEDIA"
              type="checkbox"
              role="switch"
              name="ACTIVATE_SOCIAL_MEDIA"
              checked={setRuleKeyStrokeData?.activateScreenshot ?? 0}
              onChange={handleChange}
            />
            <label className="form-check-label" htmlFor="ACTIVATE_SOCIAL_MEDIA">
              <span className="text-dark fw-semibold">
                {getLangTranslation(
                  "KEYSTROKES_MONITORING_ACTIVATE_KEYWORD_ALERT_ON_SOCIAL_COMMUNICATION",
                  "Activate keywords alerts on social media communication"
                )}
              </span>
              <p className="text-small">
                {getLangTranslation(
                  "KEYSTROKES_MONITORING_ACTIVATE_KEYWORD_ALERT_ON_SOCIAL_COMMUNICATION_DESCRIPTION",
                  "This option will allow you to get alerted when any keywords above is detected when receiving notification messages on social media apps."
                )}
              </p>
            </label>
          </div>
        </>
      )}
    </>
  );
};

export default KeyStrokes;
